export default class Theme {
    static setInitial() {
        this.setTheme(this.getPreferredTheme());
    }
    static setupEvents() {
        if (window.matchMedia) {
            const matchMedia = window.matchMedia('(prefers-color-scheme: dark)');
            if (matchMedia.addEventListener) {
                matchMedia.addEventListener('change', () => {
                    const storedTheme = this.getStoredTheme();
                    if (storedTheme !== 'light' && storedTheme !== 'dark') {
                        this.setTheme(this.getPreferredTheme());
                    }
                });
            }
        }
        window.addEventListener('DOMContentLoaded', () => {
            this.showActiveTheme(this.getPreferredTheme());
            document.querySelectorAll('[data-bs-theme-value]')
                .forEach(toggle => {
                toggle.addEventListener('click', () => {
                    const theme = toggle.getAttribute('data-bs-theme-value');
                    this.setStoredTheme(theme);
                    this.setTheme(theme);
                    this.showActiveTheme(theme, true);
                });
            });
        });
    }
    static getStoredTheme() {
        return localStorage.getItem('theme');
    }
    static setStoredTheme(theme) {
        localStorage.setItem('theme', theme);
    }
    static getPreferredTheme() {
        const storedTheme = this.getStoredTheme();
        if (storedTheme) {
            return storedTheme;
        }
        if (!window.matchMedia) {
            return 'light';
        }
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    static setTheme(theme) {
        if (theme === 'auto') {
            document.documentElement.setAttribute('data-bs-theme', (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'));
        }
        else {
            document.documentElement.setAttribute('data-bs-theme', theme);
        }
    }
    static showActiveTheme(theme, focus = false) {
        const themeSwitcher = document.querySelector('#bd-theme');
        if (!themeSwitcher) {
            return;
        }
        const themeSwitcherText = document.querySelector('#bd-theme-text');
        const btnToActive = document.querySelector(`button[data-bs-theme-value="${theme}"]`);
        document.querySelectorAll('button[data-bs-theme-value]').forEach(element => {
            element.classList.remove('active');
            element.setAttribute('aria-pressed', 'false');
        });
        btnToActive.classList.add('active');
        btnToActive.setAttribute('aria-pressed', 'true');
        const themeSwitcherLabel = `Theme (${btnToActive.dataset.bsThemeValue})`;
        themeSwitcher.setAttribute('aria-label', themeSwitcherLabel);
        themeSwitcherText.innerHTML = btnToActive.innerHTML + ' Theme';
        if (focus) {
            themeSwitcher.focus();
        }
    }
}
Theme.setInitial();
Theme.setupEvents();
